import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
export var layoutToFlexWidths = function layoutToFlexWidths(layout, totalSlides) {
  if (!layout) {
    return [];
  }
  var layoutValues = layout === null || layout === void 0 ? void 0 : layout.split('-').map(function (i) {
    var value = parseInt(i);

    // 33-33-33 is the only supported layout where values don't sum to 100. We need to
    // account for this in order for slides not to be cut off.
    return value === 33 ? value + 1 / 3 : value;
  });
  var numLayoutValues = layoutValues.length;
  return layoutValues.reduce(function (acc, value) {
    acc.push("".concat(value / (totalSlides / numLayoutValues), "%"));
    return acc;
  }, []);
};